import { SortDirections } from "client/interfaces/Misc";
import { ProjectStates } from "client/interfaces/ProjectStates";
import { ScenarioSortAttributes } from "client/interfaces/Worklink";

export const LIST_APP_SCENARIOS = `
query GetAppScenarios($first: Int, $after: Int, $filter: ScenariosQueryInputObject) {
	scenarios(first: $first, afterIndex: $after, scenariosQueryArguments: $filter) {
		totalCount
		pageInfo {
			hasNextPage
			hasPreviousPage
		}
		nodes {
			name
			description
			id
			publishedAt
			currentRelease {
				sdkVersion
				createdAt
				projectSaveFile {
					id
					project {
						id
						name
					}
					file {
						fileUrl
					}
				}
			}			
			state
			revisionName
			revisionGroupName
			revisionNotes
			revisions(scenariosQueryArguments: $filter) {
				id
				state
			}
		}
	}
}
`;

export const GET_APP_SCENARIO = `
query GetScenario($id: ID, $filter: ScenariosQueryInputObject) {
	scenario(id: $id) {
		id
		revisions(scenariosQueryArguments: $filter) {
			name
			description
			id
			publishedAt
			currentRelease {
				sdkVersion
				createdAt
				projectSaveFile {
					id
					project {
						id
						name
					}
					file {
						fileUrl
					}
				}
			}
			state
			revisionGroupName
			revisionName
			revisionNotes
		}
	}
}
`;

export const GET_APP_SCENARIO_PROJECT = `
query GetScenarioProject($id: ID) {
  scenario(id: $id) {
    currentRelease {
      projectSaveFile {
        project {
          id
          databaseId
          name
          state
          createdAt
          revisionName
          scopeCreateVersion
          updatedAt
          revisionName
          revisionGroupName
          revisionNumber
          version
          permissions {
            canView {
              value
            }
          }
        }
      }
    }
  }
}	
`

export interface IListAppScenariosResponse {
	scenarios: {
		totalCount: number;
		pageInfo: {
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		},
		nodes: Array<IAppScenario>;
	};
}

export interface IAppScenario {
	name: string;
	description?: string;
	id: string;
	publishedAt?: string;
	currentRelease?: {
		sdkVersion?: string;
		createdAt?: string;
		projectSaveFile?: {
			id: string;
			project?: {
				id: string;
				name: string;
			};
			file: {
				fileUrl: string;
			},
		},
	};
	state?: ProjectStates;
	revisionName?: string;
	revisionGroupName?: string;
	revisionNotes?: string;
	revisions?: Array<IAppScenario>;
}

export interface IListAppScenariosFilterVariables {
	appList?: boolean;
	published?: boolean;
	fullText?: string;
	orderBy?: {
		attribute: ScenarioSortAttributes;
		direction: SortDirections;
	};
	states?: ProjectStates[];
	scopeCreateVersionRange?: string;
}